"use client";

import { useMemo } from "react";
import type { PaginatedResultOfGetMakeupResponse } from "@/openapi/generated";
import { MakeupStatus } from "@/openapi/generated";
import { toMakeupMemberId } from "@/lib/services/makeupService";
import { useMakeupSessionsSearch } from "./useMakeupSessionsSearch";

export function useMemberMakeupsNeedingActionCount(
  enabled: boolean,
  memberId: number | null | undefined,
) {
  const resolvedMemberId = toMakeupMemberId(memberId);
  const filters = useMemo(
    () =>
      resolvedMemberId != null
        ? {
            memberId: resolvedMemberId,
            status: MakeupStatus.ChangeRequested,
          }
        : {},
    [resolvedMemberId],
  );

  const { data, isPending } = useMakeupSessionsSearch({
    page: 1,
    pageSize: 1,
    filters,
    enabled: enabled && resolvedMemberId != null,
  });

  const count = useMemo(() => {
    const raw = (data as PaginatedResultOfGetMakeupResponse | undefined)
      ?.totalCount;
    return typeof raw === "number" ? raw : Number(raw ?? 0);
  }, [data]);

  return { count, isPending };
}
